<div disabled="period." *transloco="let t" class="detail-background">
	<ara-period-settings [billingId]="billingId()" [periods]="periods()"></ara-period-settings>
</div>
